const smallestImperialStep = 0.396875;

export default smallestImperialStep;
